import script from "./TheModal.vue?vue&type=script&setup=true&lang=js"
export * from "./TheModal.vue?vue&type=script&setup=true&lang=js"

import "./TheModal.vue?vue&type=style&index=0&id=757fbd54&lang=css"

const __exports__ = script;

export default __exports__